import { DeliveryProvider } from '../../../../services/exports/Constants';

export default {
  [DeliveryProvider.Standalone]: 'Eigen bezorgvloot',
  [DeliveryProvider.UberDrive]: 'Uber drive',
  [DeliveryProvider.WoltDrive]: 'Wolt drive',
};
